












import { Component, Prop, Vue } from "vue-property-decorator";
import { ITag } from "@/models/tags";
import { IBasketProduct } from "@/models/baskets";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "tags-provider": () =>
      import("@/components/app/global/tags/tagsProvider.vue"),
    "tags-view": () => import("@/components/app/global/tags/tagsView.vue")
  }
})
export default class ProductTags extends Vue {
  public $refs!: {
    dropdown: Vue;
  };

  // Props
  @Prop({ required: true })
  public product!: IBasketProduct;

  @Prop({ default: false })
  public isRightAligned!: boolean;

  // Data
  public isProcessing = false;

  // Getters
  public get productTags(): ITag[] {
    return this.$_.get(this.product, "tags", []);
  }

  // Methods

  public assignTags(productId, tagIds) {
    return this.$store.dispatch(`data/${DataModules.ORDERS}/syncProductTags`, {
      id: productId,
      data: {
        tag_ids: tagIds
      }
    });
  }

  public onRemoveTag(tag: ITag) {
    const tags = this.productTags.filter(i => i.id !== tag.id);
    // Remove tag from products tags array for better UI/UX, it will be overriden when order is reloaded
    if (this.product.tags) {
      const index = this.product.tags.findIndex(i => i.id === tag.id);
      this.product.tags.splice(index, 1);
    }
    this.save(tags.map(i => i.id));
  }

  public save(tagIds) {
    this.isProcessing = true;
    return this.assignTags(this.product.id, tagIds)
      .then(() => {
        this.$emit("save");
      })
      .catch(error => {
        this.$store.dispatch("api/handleError", error);
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  public openManageModal() {
    this.$store.dispatch(`data/${DataModules.TAGS}/openManageModal`, {
      events: {
        delete: () => this.$emit("save"),
        update: () => this.$emit("save")
      }
    });
  }
}
